import React from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import FolderForm from "./FolderForm";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const FolderFormView = ({ folder, ...rest }) => {
  const classes = useStyles();

  const editMode = rest.kmaction === "edit";

  let pageTitle = rest.kmaction === "new" ? "Nowy katalog" : "Edycja katalogu";

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <FolderForm editMode={editMode}/>
        </Box>
      </Container>
    </Page>
  );
};

export default FolderFormView;
